// CRM 2.0 · M12-F4: the values of one QR page as the signatory reads the paper: a card per group (Applicant 1 ·
// <name>, Unit, Price …) and one row per value; "was …" under a value that changed since I signed; the payment
// schedule as a table like the print; on the copy QR the earlier copies as a timeline (the last one shown, the rest
// behind "Show N more").
import React, { useState } from "react";
import cls from "./Crm2Verify.module.css";

const SHOWN_COPIES = 1;

function Timeline({ items }) {
  const [all, setAll] = useState(false);
  const list = all ? items : items.slice(0, SHOWN_COPIES);
  const more = items.length - SHOWN_COPIES;
  return (
    <>
      <ol className={cls.timeline}>
        {list.map((t) => (
          <li key={t.title}>
            <b>{t.title}</b>
            {t.lines.map((line) => <span key={line} className={/^Reason:/.test(line) ? cls.tlReason : undefined}>{line}</span>)}
          </li>
        ))}
      </ol>
      {more > 0 && (
        <button className={cls.moreBtn} onClick={() => setAll((x) => !x)} aria-expanded={all}>
          {all ? "Show less" : `Show ${more} more earlier ${more === 1 ? "copy" : "copies"}`}
        </button>
      )}
    </>
  );
}

function SheetGroups({ groups }) {
  return (groups || []).map((g, gi) => (
    <section key={`${g.title}-${gi}`} className={cls.group}>
      <h5 className={cls.groupTitle}>{g.title}</h5>
      {g.table && (
        <>
          {g.tableChanged && <p className={cls.changed}>The schedule changed since you signed</p>}
          <div className={cls.tableWrap}>
            <table className={cls.schedule}>
              <thead><tr>{g.table.columns.map((c) => <th key={c} scope="col">{c}</th>)}</tr></thead>
              <tbody>{g.table.rows.map((r, i) => <tr key={i}>{r.map((v, j) => <td key={j}>{v}</td>)}</tr>)}</tbody>
            </table>
          </div>
        </>
      )}
      {g.rows && g.rows.length > 0 && (
        <ul className={cls.rows}>
          {g.rows.map((r, i) => (
            <li key={`${r.label}-${i}`}>
              <span className={cls.rLabel}>{r.label}</span>
              <span className={cls.rValue}>{r.value}</span>
              {r.was !== undefined && <span className={cls.rWas}>was <s>{r.was}</s></span>}
            </li>
          ))}
        </ul>
      )}
      {g.timeline && <Timeline items={g.timeline} />}
    </section>
  ));
}

// View of a signed copy: the saved values carry their group title
export function groupsOfShown(values) {
  const groups = [];
  (values || []).forEach((v) => {
    const title = v.group || "Values";
    let g = groups.find((x) => x.title === title);
    if (!g) { g = { title, rows: [] }; groups.push(g); }
    g.rows.push({ label: v.label, value: v.value });
  });
  return groups;
}

export default SheetGroups;
